// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-checkbox[data-v-0006fb69]{margin-left:16px}", ""]);
// Exports
module.exports = exports;
